export const roles = {
  TEAM_LEAD: 1,
  TEAM_MEMBER: 2,
};

const roleNames = {
  [roles.TEAM_LEAD]: 'Team lead',
  [roles.TEAM_MEMBER]: 'Team member',
};

export const getUserRole = (role) => {
  if (role === null) return 'Administrator';
  return roleNames[role] ?? 'Unknown';
};
